/**
 * Page de vérification d'email FrontOffice
 */

import { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { authApi, getBrandInfo } from '@e-store/shared';
import './auth.css';

export function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [isVerifying, setIsVerifying] = useState(true);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const verifyEmail = async () => {
      if (!token) {
        setError('Token de vérification manquant.');
        setIsVerifying(false);
        return;
      }

      const response = await authApi.verifyEmail({ token });

      if (response.error) {
        setError(response.error);
      } else {
        setSuccess(true);
      }
      setIsVerifying(false);
    };

    verifyEmail();
  }, [token]);

  return (
    <div className="auth-page frontoffice">
      <div className="auth-container">
        <div className="auth-header">
          <h1>{getBrandInfo().name}</h1>
          <h2>Vérification de l'email</h2>
        </div>

        {isVerifying ? (
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <p style={{ color: '#64748b' }}>Vérification en cours...</p>
          </div>
        ) : success ? (
          <div className="success-block">
            <div className="success-message">
              Email vérifié avec succès !
            </div>
            <p className="success-text">
              Votre compte a été activé. Vous pouvez maintenant vous connecter.
            </p>
            <Link to="/login" className="btn-primary" style={{ display: 'block', textAlign: 'center', marginTop: '20px' }}>
              Se connecter
            </Link>
          </div>
        ) : (
          <div className="error-block">
            <div className="error-message">{error}</div>
            <p>Le lien de vérification est invalide ou a expiré.</p>
            <Link to="/register" className="btn-primary" style={{ display: 'block', textAlign: 'center', marginTop: '20px' }}>
              Créer un nouveau compte
            </Link>
          </div>
        )}

        <div className="back-link">
          <Link to="/">Retour à l'accueil</Link>
        </div>
      </div>
    </div>
  );
}
